import { IS_PHONE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { forceVigboLinkedAccount, vigboTariffs } from 'reactApp/appHelpers/featuresHelpers/features/vigbo';
import { handleBillingDataSuccess } from 'reactApp/modules/billingData/billingData.handler.saga';
import { getBillingDataRequestIfNotLoaded } from 'reactApp/modules/billingData/billingData.module';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { getVigboLinkState } from 'reactApp/modules/vigbo/vigbo.selectors';
import { VigboAccountLinkState } from 'reactApp/modules/vigbo/vigbo.types';
import { store as reduxStore } from 'reactApp/store';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { put, select } from 'typed-redux-saga';

import { storeHelper } from '../promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from '../promo.module';
import { EPromoType } from '../promo.types';

export const PROMO_ID = 'link-vigbo-account-tooltip';

// eslint-disable-next-line complexity
export function* initLinkVigboAccount() {
    const storage = yield* select(getCurrentStorage);
    const {
        isHome,
        isGallery,
        isAlbums,
        isTrashBin,
        isFavorites,
        isFamilyFolders,
        isStart,
        isAttachesStorage,
        isSharedLinks,
        isSharedAutodelete,
        isSharedIncoming,
        isDocuments,
        isFeed,
    } = getStorage(storage);
    const isProperStorageType =
        isHome ||
        isGallery ||
        isAlbums ||
        isTrashBin ||
        isFavorites ||
        isFamilyFolders ||
        isStart ||
        isAttachesStorage ||
        isSharedLinks ||
        isSharedAutodelete ||
        isSharedIncoming ||
        isDocuments ||
        isFeed;

    const accountLinkState = yield* select(getVigboLinkState);
    const isLinkedAccount = forceVigboLinkedAccount || accountLinkState === VigboAccountLinkState.linked;

    const alreadyShown = storeHelper.getValue(PROMO_ID);

    const isPaid = yield* select(UserSelectors.isPaidUser);
    const isCorpUser = yield* select(UserSelectors.isCorpUser);
    const isBizUser = yield* select(UserSelectors.isBizUser);
    const isSocialUser = yield* select(UserSelectors.isSocialUser);

    const isMobile = EnvironmentSelectors.isMobile();

    /**
     * Не показываем если:
     * - Не подходящий раздел
     * - Пользователь уже связал аккаунты
     * - Уже показывали
     * - Корпам, бизам, соцникам и бесплатникам
     * - На мобилках
     */
    if (
        !isProperStorageType ||
        isLinkedAccount ||
        alreadyShown ||
        isCorpUser ||
        isBizUser ||
        isSocialUser ||
        !isPaid ||
        isMobile ||
        IS_WEBVIEW ||
        IS_PHONE_BROWSER
    ) {
        return;
    }

    yield* put(getBillingDataRequestIfNotLoaded());
    const billingDataSuccess = yield* handleBillingDataSuccess();
    if (!billingDataSuccess) {
        return;
    }

    const vigboSubs = yield* select(BillingDataSelectors.getSubscriptionsByProductIds, vigboTariffs);
    if (vigboSubs.length === 0) {
        return;
    }

    yield* put(
        addPromoToShowQueue({
            type: EPromoType.linkVigboAccountTooltip,
            promoId: PROMO_ID,
            onShow: () => {
                reduxStore.dispatch(promoShown(EPromoType.linkVigboAccountTooltip));
                sendPaymentGa({
                    eventCategory: ECategoryGa.tooltip,
                    action: 'show',
                    name: 'connection_photographer_sub',
                });
            },
            onClose: () => {
                reduxStore.dispatch(removePromo(EPromoType.linkVigboAccountTooltip));
            },
            onClick: () => {
                reduxStore.dispatch(removePromo(EPromoType.linkVigboAccountTooltip));
                storeHelper.markAsShown(PROMO_ID);
                sendPaymentGa({
                    eventCategory: ECategoryGa.tooltip,
                    action: 'click',
                    name: 'connection_photographer_sub',
                });
            },
            onCrossClose: () => {
                storeHelper.markAsShown(PROMO_ID);
            },
        })
    );
}
